// extracted by mini-css-extract-plugin
export default {"pill":"TutorialPausedPill_pill__ViJNC","label":"TutorialPausedPill_label__p9rZr","action":"TutorialPausedPill_action__vmVNn"};